/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_Prefs_TitleInputs */

const da_consent_prefs_title = /** @type {(inputs: Consent_Prefs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookieindstillinger`)
};

/** @type {(inputs: Consent_Prefs_TitleInputs) => LocalizedString} */
const en_consent_prefs_title = da_consent_prefs_title;

/**

* @param {Consent_Prefs_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const consent_prefs_title = /** @type {((inputs?: Consent_Prefs_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_Prefs_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_consent_prefs_title(inputs)
	return /** @type {LocalizedString} */ ("Cookieindstillinger")
});